/**
 * SandboxOverviewPanel — the Overview tab of the sandbox sidebar: the sandbox
 * actions, full-bleed (run-panel style). Purpose + Instance summary live in the
 * header gear fly-up (`SandboxSettingsOverlay`); health checks live in the
 * Diagnostics tab.
 */
import React from 'react';
import { Text } from '@chatsdet/ui';
import type { EnvironmentInstance } from '../../../hooks/useEnvironmentInstances';
import { SandboxActionsPanel } from './SandboxActionsPanel';

export interface SandboxOverviewPanelProps {
  instance: EnvironmentInstance;
}

export function SandboxOverviewPanel({ instance }: SandboxOverviewPanelProps) {
  const isRunning = instance.status === 'running';

  return (
    <div className="h-full overflow-y-auto">
      {isRunning ? (
        <SandboxActionsPanel instanceId={instance.id} />
      ) : (
        <div className="p-6 text-center">
          <Text size="sm" color="muted">
            Actions are available while the sandbox is running.
          </Text>
        </div>
      )}
    </div>
  );
}

SandboxOverviewPanel.displayName = 'SandboxOverviewPanel';
